import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { CiEdit } from 'react-icons/ci';


interface BusinessStructure {
    id:number; 
  giver :number; 
  receiver: number;
  workBy:string;
  referenceId:string;
  status : string;
  date:string;
  amount:number;
  Testimonial :string;
  }

  interface ReportStructure {
    InitiatedBy :number; 
    approve : string;
    date:string;
    discussion_point:string;
    id:number; 
    image:string;
    location: string;
    meetingWith: number;
    type:string;
    }
  interface UserStructure {
    id: number;
    name: string;
  }
  
  interface ReferenceStructure {
    id:number; 
    referenceTo :number; 
    referenceBy: number;
    RefPerName:string;
    number:string;
    date:string;
  }
const Activity = () => {
    const api = process.env.REACT_APP_API_URL as string;
    const [activeTab, setActiveTab] = useState('business'); // State for active tab
     const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);
     const [isReportModalOpen, setIsReportModalOpen] = useState(false);
       const [userData, setUserData] = useState<UserStructure[]>([]);
        const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
       const [businessData, setBusinessData] = useState<BusinessStructure[]>([]);
  const [reportData, setReportData] = useState<ReportStructure[]>([]);
   const [referenceData, setReferenceData] = useState<ReferenceStructure[]>([]);

   const[cuurentUserId, setCurrentUserID] = useState();
   const[cuurentUserRole, setCurrentUserRole] = useState();


   useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/reference`
        );

        // console.log("business data", response.data);
        setReferenceData(response.data.data);
        // console.log("report data in a array", reportData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/memeberpoint`
        );

        // console.log("member data", response.data);
        setReportData(response.data);
        // console.log("report data in a array", reportData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

       useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${api}/auth/business`
            );
    
            // console.log("business data", response.data.data);
            setBusinessData(response.data.data);
            // console.log("report data in a array", businessData.length);
          } catch (error) {
            console.error("user Not Found:", error);
          }
        };
    
        fetchData();
      }, []);
      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get<UserStructure[]>(
              `${api}/auth/allusersinfo`
            );
    
            //console.log("news data", response.data);
            setUserData(response.data);
            //console.log("user data in a array", newData);
          } catch (error) {
            console.error("user Not Found:", error);
          }
        };
    
        fetchData();
      }, []);
    const [userId, setUSerID] = useState();
    useEffect(() => {
        const validateSession = async () => {
          try {
            // Validate the session and retrieve user ID
            const response = await axios.get(`${api}/auth/memberLoggedIn`, {
              withCredentials: true,
            });
            //console.log('Dashboard data:', response.data);
            const uid = response.data.user.id;
            setUSerID(uid);
            setCurrentUserID(uid);
            setCurrentUserRole(response.data.user.role);
          } catch (error: any) {
          }
        };
    
        validateSession();
      }, []);

      const openBusinessModal = (postId: number) => {
        setSelectedUserId(postId);
        setIsBusinessModalOpen(true);
      };
    
      // Function to close modal and clear the post ID
      const closeBusinessModal = () => {
        setSelectedUserId(null);
        setIsBusinessModalOpen(false);
      };

      const openReportModal = (postId: number) => {
        setSelectedUserId(postId);
        setIsReportModalOpen(true);
      };
    
      // Function to close modal and clear the post ID
      const closeReportModal = () => {
        setSelectedUserId(null);
        setIsReportModalOpen(false);
      };


      const renderBusinessTable = () => (
        <div className="px-2 py-3 overflow-x-auto">
            <table className="table-auto w-full border-collapse border bg-white border-gray-300">
       <thead className="bg-darkblue text-white">
         <tr>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Date</th>
           
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Giver</th>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Receiver</th>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Self / Reference</th>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Status</th>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Amount</th>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left">Testimonial </th>
           <th className="border-y border-y-gray-300 px-4 py-2 text-left"></th>
         </tr>
       </thead>
       <tbody>
         {businessData.length > 0 ? (
  (cuurentUserRole === "super-admin"
    ? businessData
    : businessData.filter(
        (item) => item.giver === userId || item.receiver === userId
      )
  ).map((item) => (
    <tr key={item.id} className="border border-gray-300">
      <td className="border-y border-y-gray-300 px-4 py-2">
        {item.date.split("T")[0]}
      </td>

      <td className="border-y border-y-gray-300 px-4 py-2">
        {userData.find((u) => u.id === item.giver)?.name || "N/A"}
      </td>

      <td className="border-y border-y-gray-300 px-4 py-2">
        {userData.find((u) => u.id === item.receiver)?.name || "N/A"}
      </td>

      <td className="border-y border-y-gray-300 px-4 py-2">{item.workBy}</td>

      <td
        className={`border-y border-y-gray-300 px-4 py-2 ${
          item.status === "Approve"
            ? "text-green-600"
            : item.status === "Pending"
            ? "text-textyellow"
            : "text-red-600"
        }`}
      >
        {item.status}
      </td>

      <td className="border-y border-y-gray-300 px-4 py-2">₹{new Intl.NumberFormat('en-IN').format(item.amount)}</td>
      <td className="border-y border-y-gray-300 px-4 py-2">{item.Testimonial}</td>

      <td className="border-y border-y-gray-300 px-4 py-2">
        <div className="flex gap-4">
          <button
            className="flex items-center gap-2 px-3 py-1 border border-darkblue text-darkblue rounded-lg hover:bg-darkblue hover:text-white"
            onClick={() => openBusinessModal(item.id)}
          >
            <CiEdit />
          </button>
        </div>
      </td>
    </tr>
  ))
) : (
  <tr>
    <td colSpan={8} className="text-center py-4">
      Loading...
    </td>
  </tr>
)}

       </tbody>
     </table>
 
     {isBusinessModalOpen && (
           <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
             <div className="bg-white rounded-lg w-[50%] h-auto">
               {/* Close button */}
               {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
          X
        </button> */}
               <BusinessModal activityId={selectedUserId} onClose={closeBusinessModal} />
             </div>
           </div>
         )}
     </div>
      );
    
      // Render Report Data Table
      const renderReportTable = () => (
        <div className="px-2 py-3 overflow-x-auto">
                <table className="table-auto w-full border-collapse border bg-white border-gray-300">
           <thead className="bg-darkblue text-white">
             <tr>
               <th className="border-y border-y-gray-300 px-4 py-2 text-left">Date</th>
               <th className="border-y border-y-gray-300 px-4 py-2 text-left">Type</th>
               
               <th className="border-y border-y-gray-300 px-4 py-2 text-left">Host By</th>
               <th className="border-y border-y-gray-300 px-4 py-2 text-left">Guest</th>
               <th className="border-y border-y-gray-300 px-4 py-2 text-left">Image</th>
               <th className="border-y border-y-gray-300 px-4 py-2 text-left">Status</th>
               {/* <th className="border-y border-y-gray-300 px-4 py-2 text-left"></th> */}
             </tr>
           </thead>
           <tbody>
             {reportData.length > 0 ? ((cuurentUserRole == "super-admin"?reportData:
               reportData.filter((items)=>items.InitiatedBy===userId || items.meetingWith === userId)).map((item) => (
                 <tr  className="border border-gray-300">
                  <td className="border-y border-y-gray-300 px-4 py-2">
                     {item.date.split('T')[0]}
                   </td>

                   <td className="border-y border-y-gray-300 px-4 py-2">
                     {item.type}
                   </td>

                   
                   
                   <td className="border-y border-y-gray-300 px-4 py-2">
       {userData.find((items) => items.id === item.InitiatedBy)?.name || "N/A"}
     </td>
     
     <td className="border-y border-y-gray-300 px-4 py-2">
       {userData.find((items) => items.id === item.meetingWith)?.name || "N/A"}
     </td>
                   <td className="border-y border-y-gray-300 px-4 py-2"><img
                       className="h-[100px] object-cover w-[100px]"
                       src={
                         item.image
                           ? item.image.startsWith("http")
                             ? item.image
                             : `${api}/uploads/${item.image}`
                           : "https://via.placeholder.com/150"
                       }
                       alt={item.type || "Image"}
                     /></td>
                      <td className={`border-y border-y-gray-300 px-4 py-2 ${item.approve=='Approve'?'text-green-600':item.approve=='Pending'?'text-textyellow':'text-red-600'}`}>{item.approve}</td>
                   {/* <td className="border-y border-y-gray-300 px-4 py-2">
                     <div className="flex gap-4">
                       <button
                         className="flex items-center gap-2 px-3 py-1 border border-darkblue text-darkblue rounded-lg hover:bg-darkblue hover:text-white"
                         onClick={() => openReportModal(item.id)}
                       >
                         <CiEdit />
                       </button>
                     </div>
                   </td> */}
                 </tr>
               ))
             ) : (
               <tr>
                 <td colSpan={7} className="text-center py-4">
                   Loading...
                 </td>
               </tr>
             )}
           </tbody>
         </table>
     
         {isReportModalOpen && (
               <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                 <div className="bg-white rounded-lg w-[50%] h-auto">
                   {/* Close button */}
                   {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
                   <ReportModal activityId={selectedUserId} onClose={closeReportModal} />
                 </div>
               </div>
             )}
         </div>
      );
    
      // Render Points Data Table
      const renderReferenceTable = () => (
        <div className="px-2 py-3 overflow-x-auto">
        <table className="table-auto w-full border-collapse border bg-white border-gray-300">
   <thead className="bg-darkblue text-white">
     <tr>
       <th className="border-y border-y-gray-300 px-4 py-2 text-left">Date</th>
       
       <th className="border-y border-y-gray-300 px-4 py-2 text-left">Reference To</th>
       <th className="border-y border-y-gray-300 px-4 py-2 text-left">Reference By</th>
       <th className="border-y border-y-gray-300 px-4 py-2 text-left">Reference Person Name</th>
       <th className="border-y border-y-gray-300 px-4 py-2 text-left">Mobile Number</th>
       </tr>
   </thead>
   <tbody>
     {referenceData.length > 0 ? ((
      cuurentUserRole =="super-admin"?referenceData:
       referenceData.filter((items)=>items.referenceBy===userId || items.referenceTo === userId)).map((item) => (
         <tr  className="border border-gray-300">
           <td className="border-y border-y-gray-300 px-4 py-2">
             {item.date.split('T')[0]}
           </td>
           
           <td className="border-y border-y-gray-300 px-4 py-2">
{userData.find((items) => items.id === item.referenceTo)?.name || "N/A"}
</td>

<td className="border-y border-y-gray-300 px-4 py-2">
{userData.find((items) => items.id === item.referenceBy)?.name || "N/A"}
</td>
<td className="border-y border-y-gray-300 px-4 py-2">
{item.RefPerName}
           </td>
           {/* <td className="border-y border-y-gray-300 px-4 py-2"></td> */}
              
           <td className="border-y border-y-gray-300 px-4 py-2">
{item.number}
           </td>
              
           
         </tr>
       ))
     ) : (
       <tr>
         <td colSpan={7} className="text-center py-4">
           Loading...
         </td>
       </tr>
     )}
   </tbody>
 </table>

 </div>
      );
  return (
    <div>
    {/* Tab Navigation */}
    <div className="flex flex-wrap justify-center items-center gap-4 bg-gray-100 p-4 rounded-b-xl shadow-md">
  <button
    onClick={() => setActiveTab('business')}
    className={`w-full sm:w-auto px-6 py-3 text-sm font-medium rounded-lg transition-all duration-300 ${
      activeTab === 'business'
        ? 'bg-darkblue text-white shadow-md scale-105'
        : 'bg-white text-darkblue hover:bg-gray-200'
    }`}
  >
    Business
  </button>
  <button
    onClick={() => setActiveTab('report')}
    className={`w-full sm:w-auto px-6 py-3 text-sm font-medium rounded-lg transition-all duration-300 ${
      activeTab === 'report'
        ? 'bg-darkblue text-white shadow-md scale-105'
        : 'bg-white text-darkblue hover:bg-gray-200'
    }`}
  >
    Report
  </button>
  <button
    onClick={() => setActiveTab('Reference')}
    className={`w-full sm:w-auto px-6 py-3 text-sm font-medium rounded-lg transition-all duration-300 ${
      activeTab === 'Reference'
        ? 'bg-darkblue text-white shadow-md scale-105'
        : 'bg-white text-darkblue hover:bg-gray-200'
    }`}
  >
    Reference
  </button>
</div>


    {/* Tab Content */}
    {activeTab === 'business' && renderBusinessTable()}
    {activeTab === 'report' && renderReportTable()}
    {activeTab === 'Reference' && renderReferenceTable()}
  </div>
   )
}


interface BusinessModalProps {
  activityId?: number | null;
  onClose: () => void;
}

// Decrypt function


const BusinessModal: React.FC<BusinessModalProps> = ({ activityId, onClose }) => {
  const api = process.env.REACT_APP_API_URL as string;
  const [userData, setUserData] = useState<UserStructure[]>([]);
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown menu visibility
  const dropdownRef = useRef<HTMLDivElement | null>(null); // Type the ref here
  // Reference for the dropdown menu

  const [businessData, setBusinessData] = useState<BusinessStructure[]>([]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<UserStructure[]>(
          `${api}/auth/allusersinfo`
        );

        //console.log("news data", response.data);
        setUserData(response.data);
        //console.log("user data in a array", newData);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  const [formData, setFormData] = useState({
    approve: "",
    Testimonial:"",
  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (activityId != -1) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(
            `${api}/auth/business/${activityId}`
          );

          const data = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          // Access the first element

          // console.log('user data from one id',data);   
          // Destructure from the first element of the array
          const {
            status,
            Testimonial,
            amount,
            referenceId,
            giver,
            date,


          } = data;
          setBusinessData(data.data);


        //  businessData[0].status; 
        // console.log('data  of busness',data.data[0].status);
          setFormData({
            approve: data.data[0].status,
            Testimonial
  
          });

        } catch (err) {
          console.error("Error fetching users:", err);
        }
      };
      fetchPost();
    }
  }, [activityId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.approve) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
    data.append("status", formData.approve);
    data.append("Testimonial", formData.Testimonial);

    try {
      
        await axios.put(`${api}/auth/business/${activityId}`, data, {
          headers: { "Content-Type": "application/json" },
        });
      onClose();
      window.location.reload();
    } catch (err) {
      
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white lg:w-1/2 w-[96%] p-6 rounded shadow relative h-auto overflow-y-auto">
        <form onSubmit={handleSubmit} className="space-y-4 grid ">
        <div className="">
        {businessData.map((items) => (
    <div key={items.id} className="bg-white rounded-lg shadow-lg p-3 grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-6">
      {/* Date Field */}
      <div>
        <label className="text-[#030303] font-semibold text-lg">Date</label>
        <div className="mt-2 p-3 text-gray-700 bg-[#F9FAFB] border border-[#E2E8F0] rounded-md">
          {items.date.split("T")[0]}
        </div>
      </div>

      {/* Giver Field */}
      <div>
        <label className="text-[#030303] font-semibold text-lg">Giver</label>
        <div className="mt-2 p-3 text-gray-700 bg-[#F9FAFB] border border-[#E2E8F0] rounded-md">
          {userData.find((user) => user.id === items.giver)?.name || "N/A"}
        </div>
      </div>

      {/* Receiver Field */}
      <div>
        <label className="text-[#030303] font-semibold text-lg">Receiver</label>
        <div className="mt-2 p-3 text-gray-700 bg-[#F9FAFB] border border-[#E2E8F0] rounded-md">
          {userData.find((user) => user.id === items.receiver)?.name || "N/A"}
        </div>
      </div>

      {/* Amount Field */}
      <div>
        <label className="text-[#030303] font-semibold text-lg">Amount</label>
        <div className="mt-2 p-3 text-gray-700 bg-[#F9FAFB] border border-[#E2E8F0] rounded-md">
          ₹{new Intl.NumberFormat('en-IN').format(items.amount)}
        </div>
      </div>
    </div>
  ))}
  </div>
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2">

         
          
            <div>
              <label className="text-[#030303] font-medium">Status</label>
              <select
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                value={formData.approve} // Bind to state
                onChange={
                  (e) => setFormData({ ...formData, approve: e.target.value }) // Update the role in state
                }
              >
                <option value="Approve">Approve</option>
                <option value="Pending">Pending</option>
                <option value="Reject">Reject</option>
              </select>
            </div>
            
            <div>
              <label className="text-[#030303] font-medium">Testimonial</label>
              <input
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                value={formData.Testimonial} // Bind to state
                onChange={
                  (e) => setFormData({ ...formData, Testimonial: e.target.value }) // Update the role in state
                }
               placeholder='Testimonial...'   
              >
                
              </input>
            </div>
            
           
          </div>
         
         

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            {/* Date */}

            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-semibold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.approve
                }
              >
                {activityId != -1 ? "Update status" : "Add status"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};


interface ReportModalProps {
  activityId?: number | null;
  onClose: () => void;
}

// Decrypt function
const ReportModal: React.FC<ReportModalProps> = ({ activityId, onClose }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown menu visibility
  const api = process.env.REACT_APP_API_URL as string;
  const dropdownRef = useRef<HTMLDivElement | null>(null); // Type the ref here
  // Reference for the dropdown menu

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

 

  const [formData, setFormData] = useState({
    approve: "",
  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (activityId != -1) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(
            `${api}/auth/memeberpoint/${activityId}`
          );

          const data = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          // Access the first element

          // console.log('user data from one id',data);   
          // Destructure from the first element of the array
          const {
            approve,
          } = data;

          setFormData({
            approve,
  
          });

        } catch (err) {
          console.error("Error fetching users:", err);
        }
      };
      fetchPost();
    }
  }, [activityId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Validate fields
    if (!formData.approve) {
      setError("All fields are required.");
      return;
    }

    alert(formData.approve);

    const data = new FormData();
    data.append("approve", formData.approve);

    try {
      
        await axios.put(`${api}/auth/memeberpoint/${activityId}`, data, {
          headers: { "Content-Type": "application/json" },
        });
      onClose();
      window.location.reload();
    } catch (err) {
      
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-1/2 p-6 rounded shadow relative h-auto overflow-y-auto">
        <form onSubmit={handleSubmit} className="space-y-4 grid ">
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2">

            <div>
              <label className="text-[#030303] font-medium">Status</label>
              <select
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                value={formData.approve} // Bind to state
                onChange={
                  (e) => setFormData({ ...formData, approve: e.target.value }) // Update the role in state
                }
              >
                <option value="Approve">Approve</option>
                <option value="Pending">Pending</option>
                <option value="Reject">Reject</option>
              </select>
            </div>
            
           
          </div>
         
         

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            {/* Date */}

            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-semibold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                
              >
                {activityId != -1 ? "Update status" : "Add status"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Activity